import { ADD_INPUT_TO_ARRAY_IN_REQUEST } from "../../../../enums/Request/request.types";

export const addParentTabNumberAction = (data) => {
    return {
        type: ADD_INPUT_TO_ARRAY_IN_REQUEST,
        payload: data,
    };
};
